﻿import { FormatServiceLookupEditorOptions, FormatServiceLookupPickerBase } from "@/Data/List/FormatServiceLookupEditor";
import { AccountRow } from "@/ServerTypes/Data/AccountRow";
import { AccountService } from "@/ServerTypes/Data/AccountService";
import { Decorators, WidgetProps, Fluent } from "@serenity-is/corelib";
import { AccountPickerDialog } from "./AccountPickerDialog";

export interface AccountPickerOptions extends FormatServiceLookupEditorOptions {
    filterField?: string;
    filterValue?: string;
    multiple?: boolean;
}

@Decorators.registerEditor("Matrix.Data.AccountPicker")
export class AccountPicker extends FormatServiceLookupPickerBase<AccountPickerOptions, AccountRow>  {

    constructor(options: WidgetProps<AccountPickerOptions>) {
        super({ idField: AccountRow.idProperty, textField: AccountRow.nameProperty, service: AccountService.baseUrl + "/List", ...options });
    }

    handleEditClick() {
        var dlg = new AccountPickerDialog();
        dlg.criteria = this.getFilterCriteria();
        dlg.value = this.values;
        dlg.dialogOpen();
        dlg.onSuccess = sel => {
            this.values = dlg.value;
            Fluent(this.domNode).trigger("change");
            return true;
        }
    }

    protected getLookupKey() {
        return AccountRow.lookupKey;
    }

    protected displayName() {
        return "accounts";
    }
}
